<template>
  <div class="case-share-detail">
     <div class="is-weiXin-tip hidden" :class="{'show':is_weixn()}">
          <img class="tip-open" src="@/assets/case-share-detail/what_tip.png" alt="">
      </div>
      <div class="top-bc">
        <img src="@/assets/case-share-detail/Group1556238322@3x.png" alt="" srcset="" class="bc">
      </div>
      <div class="box info question" >
        <div class="content">
           <div class="line">
            <p class="que">案件类型</p>
            <p class="ans">{{detail.typeLabel}}</p>
          </div>
          <div class="line">
            <p class="que">所在地区</p>
            <p class="ans">{{detail.provinceName}} {{detail.regionName}}</p>
          </div>
          <div class="line">
            <p class="que">案件详情</p>
            <p class="ans">{{detail.info}}</p>
          </div><div class="line">
            <p class="que">律师地区</p>
            <p class="ans">
              <img v-if="detail.preferLocalLawyer" src="@/assets/case-share-detail/Group917@2x.png" alt="" srcset="">
              <span>{{detail.preferLocalLawyer ? '优先寻找本地律师' :'全国律师可接'}}</span>
            </p>
          </div><div class="line">
            <p class="que">紧急程度</p>
            <p class="ans">
              <i>{{detail.urgencyLevel}}</i>
            </p>
          </div>
        </div>
      </div>
      <div class=" progress">
        <p class="title">服务流程</p>
        <div class="progress-content">
          <img src="@/assets/case-share-detail/11111.png" alt="" srcset="">
        </div>
      </div>
      <div class="btn-box">
        <p class="btn" @click="openApp">立即前往APP</p>
        <p class="desc">您还没安装法临律师端APP？请点击 <span @click="buttonDownload">立即下载</span></p>
      </div>
  </div>
</template>

<script>
import { buriedChannelPoint } from '@/api/common'
// import { buriedChannelPoint,buriedPoint } from '@/api/common'
import { getCommonClientConfig } from "@a";
import { isNull } from '@/libs/basics-tools'
import {lawsuitCaseInfos} from "../../api/case-share-detail";
export default {
  name: "caseShareDetail",
  data() {
    return {
      detail: {},
      downloadUrls: {},//下载地址
      urgentLists:[]
    };
  },
  mounted(){
    // buriedPoint({code: 'H5PAGE'});
    buriedChannelPoint({code:'LAWYER_GUIDE_CASE_SHARE_PAGE',type: 2, behavior: 'VI'});
    this.getApk();
  },
  components: {
    
  },
	watch: {
    $route: {
      handler(){
        this.getCaseShareDetailRes()
      },
      immediate: true
    }
	},
  methods: {
    isNull,
    /**获取案源详情信息 */
    getCaseShareDetailRes(){
      lawsuitCaseInfos({id: this.$route.query?.suitCaseId}).then((res)=>{
        this.detail = res.data
        console.log('获取案源详情信息:', res.data)
      })
    },
    // 处理详情字段转换
    caseDetailFilter(arr, val){
      const i = arr.find((item) => item.value === val)
      return i ? i.label : ''
    },
    /*判断是否微信*/
    is_weixn () {
      var ua = navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger";
    },
     /*按钮点击唤醒app*/
    openApp(){
        // buriedChannelPoint({code:'LAW_PAGE_GO_TO_APP_PAGE',type: 2, behavior: 'CK'})
        buriedChannelPoint({code:'LAWYER_GUIDE_CASE_SHARE_GO_APP_CLICK',type: 2, behavior: 'CK'})
        // /*唤醒app*/+window.location.search
        // const {search} = this.$route.query
        const {suitCaseId,serverId} = this.$route.query
        if(this.isIOSClient()){
            // window.location.href = 'Lawyer://?'+search;
            window.location.href = `Lawyer://?suitCaseId=${suitCaseId}&serverId=${serverId}&path=suit_case_server_detail`;
        }else{
            window.location.href = `yoclawyer://yoclawyer/open?suitCaseId=${suitCaseId}&serverId=${serverId}&path=suit_case_server_detail`;
        }
    },
    /*按钮点击下载*/
    buttonDownload () {
        // buriedPoint({code: 'DOWNLOAD',extra:{appType:lawsuitShare}})
        // buriedChannelPoint({code: 'LAW_PAGE_DOWN_APP_PAGE',type: 2, behavior: 'CK'})
        buriedChannelPoint({code: 'LAWYER_GUIDE_CASE_SHARE_DOWNLOAD_CLICK',type: 2, behavior: 'CK'})
        this.getApk().then( (value)=> {
            if(this.isIOSClient()){
                window.location.href = value.downloadGfUrlIos;
            }else{
                /*先喚醒安卓应用市场*/
                window.location.href = value.androidGfAppstoreUrl;
                /*防止安卓没有上架到应用市场*/
                setTimeout(function (){
                    window.location.href = value.downloadGfUrlApk;
                },500)
            }
        });
    },
     /*判断是否ios*/
    isIOSClient () {
        return this.judgeClient() === 'IOS';
    },
    /*获取操作系统*/
    judgeClient () {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //判断是否是 android终端
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 ios终端
        if (isAndroid === true) {
            return 'Android';
        } else if (isIOS === true) {
            return 'IOS';
        } else {
            return 'Android';
        }
    },
    /*获取下载地址*/
    getApk() {
      if (this.$basicsTools.isObjNull(this.downloadUrls)) {
        return getCommonClientConfig().then( (value) =>{
          this.downloadUrls = value.data;
          return  this.downloadUrls
        })
      }
      return Promise.resolve(this.downloadUrls)
    },
  },
};
</script>

<style lang="scss" scoped>
.case-share-detail{
  background: #F5F5F7;
  box-sizing: border-box;
  padding-bottom: 110px;
  height: 100vh;
  overflow-y: scroll;
  .is-weiXin-tip{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.5);
      z-index: 20;
      text-align: right;
      .tip-open{
          width: 5.08rem;
          height: 3.52rem;
          position: fixed;
          z-index: 5;
          top: 0;
          right:0.12rem;
      }
  }
  .hidden{
    display: none;
  }
  .show{
      display: block;
  }
  .top-bc{
    width: 375px;
    height:325px;
    position: relative;
    top: 0;
    .bc{
      width: 100%;
    }
  }
  .box{
    width: 351px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    padding:0 16px;
    margin: -140px auto 12px;
    overflow: hidden;
  }
  .info{
    position: relative;
    .tag{
      position: absolute;
      width: 72px;
      height: 24px;
      right: 0;
      top: 16px;
    }
    .line{
      display: flex;
      font-size: 14px;
      //margin-bottom: 16px;
      &:last-child{
        margin-bottom: 0;
      }
      .title{
        color: #6B6B6F;
        width: 80px;
        word-wrap: break-word;
        word-break: break-all;
      }
      .value{
        color: #46474B;
        flex: 1;
        word-wrap: break-word;
        word-break: break-all;
      }
    }
  }
  .question{
    h3{
      color: #111;
      font-size: 16px;
      margin-bottom: 12px;
    }
    .content{
      width: 319px;
      //background: #F5F6FF;
      box-sizing: border-box;
      //padding: 14px 8px 14px 12px;
      .line{
        display: flex;
        // height: 44px;
        // line-height: 44px;
        padding: 14px 0;
        border-bottom: 0.5px solid #e5e5e5;
        //box-shadow: inset 0px 0px 0px 0px #EEEEEE;
        &:last-child{
          margin-bottom: 0;
          border-bottom:none !important;
        }
        .que{
          color: #666;
          flex: 0 0 100px;
        }
        .ans{
          color: #333333;

          img{
            width: 16px;
            height: 14px;
            margin-right: 4px;
          }
          i{
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #EB4738;
            padding: 2px 6px;
            background: #FCF1ED;
            border-radius: 4px 4px 4px 4px;
          }
        }
      }
    }
  }
  .progress{
    font-size: 14px;
    width: 343px;
    background: #FFFFFF;
    border-radius: 8px;
    box-sizing: border-box;
    margin: auto;

    .title{
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      padding: 12px;
    }
    img{
      width: 100%;
    }
  }
  .btn-box{
    border-radius: 16px 16px 0 0;
    background: #fff;
    padding: 12px 16px 32px 12px;
    position: fixed;
    bottom: 0;
    height: 100px;
    box-sizing: border-box;
    z-index: 3;
    .btn{
      color: #fff;
      font-size: 16px;
      width: 343px;
      height: 44px;
      background: #3887F5;
      line-height: 44px;
      text-align: center;
      margin-bottom: 12px;
      border-radius: 49px;
    }
    .desc{
      text-align: center;
      font-size: 14px;
      color: #333;
      span{
       text-decoration: underline;
        color: #4A539E;
      }
    }
  }
}
</style>
